export default {
  download: {
    textAlign: 'center !important',
  },
  controls: {
    textAlign: 'right !important',
    minWidth: 100,
  },
};
